module.exports = __webpack_public_path__ + "media/images/rafikicollet-298c0acc16fbc04503bd4e1823b0607f.svg";